export default "__VITE_ASSET__Bc5JotYK__"